import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../../utils/api/fetchStrapiData';
import DedicatedDevTeams from '../../views/dedicatedDevTeams';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();

  return {
    props: { blogPosts: data },
  };
};

export default DedicatedDevTeams;
